<svelte:options tag="gema-column" />

<script>

	import { afterUpdate } from 'svelte';
	import { Props, Routes } from "web-adapter-js";

	const props = new Props();
	const route = new Routes();

	export let key = '';
	export let data = {
		items: [ ],
		selector: '',
		title: '',
		url: '',
		id: ''
	};

	const classCard = () => {
		return data.items.length  === 4 ? {
			column: 'card-column full-column sm', header: 'card-header full-header'
		} : { header: 'card-header', column: 'card-column' };
	};

	const itemStyle = () => {
		const { items } = data;
		const length = items.length;
		const styles = {
			2: {
				column: 'width: 460px', img: 'width: 460px; height: 360px;',
				title: 'font-size: 40px; line-height: 1.15; letter-spacing: -1.88px; text-align: left'
			},
			3: {
				column: 'width: 300px', img: 'width: 300px; height: 300px;', title: ''
			}
		};
		return styles[length] ? styles[length] : { column: '', img: '', title: '' };
	};

	afterUpdate(() => {
		const property = props.find(`gema-column-${key}`);
		if (!!key && property) { data = property; }
	});

	const navigation = (path) => {
		if(!!path) {
			route.emit(path, { })
		}
	};

</script>

<main>
	{#if !!data.title}
		<section>
			<h1 class="pricipal-title " style={itemStyle().title}>{ data.title }</h1>
		</section>
	{/if}

	{#if !!data.items}
		<section id="wrapper">
			{#each data.items as item}
				<div class={classCard().column} style={itemStyle().column}>
					<div class={classCard().header}>
						<a on:click={navigation(item.url)}>
							<img src={ item.image.url } class="full-img pointer" alt="column" style={itemStyle().img} />
						</a>
					</div>
					<div class="card-body" on:click={navigation(item.url)}>
						<h3 class="title">{ !!item.title ? item.title : '' }</h3>
						<p class="description">
							{ !!item.description ? item.description : '' }
						</p>
					</div>
				</div>
			{/each}
		</section>
	{/if}
</main>

<style type="text/scss">
	@import '../../../styles';
	@import '../../../scss/abstracts/mixins';

	.pricipal-title {
		text-align: center;
		@include font-poppins(32px, 600, normal, normal, 1.4,  normal, #332927);
		font-family: Poppins-SemiBold;
	}

	.pointer { cursor: pointer }
	main {  margin: 0 120px 0 120px; }

	#wrapper {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		.card-column {
			text-align: center;
			width: 230px;
			.card-header {
				img {
					width: 230px; height: 230px;
					object-fit: cover;
					border-radius: 10px;
				}
			}
			.card-body {
				margin-bottom: 15px;
				.title {
					text-align: center;
					@include font-poppins(18px, 600, normal, normal, 1.2,  normal, #332927);
					font-family: Poppins-SemiBold;
				}
				.description{
					@include font-poppins(14px, normal, normal, normal, 1.57,  normal, #706967);
					font-family: Poppins-Regular;
				}
			}

		}

		@media (max-width: 1011px) {
			justify-content: center;
			.card-column {
				margin: 10px;
			}
		}
		@media (max-width: 750px) {
			.sm {
				width: 120px;
				img {
					width: 120px !important;
					height: 120px !important;
				}
			}
		}
	}

	@media (max-width: 750px) {
		main { margin: 0  }
	}
</style>
